import React from 'react';
import PropTypes from 'prop-types';
import TooltipTrigger from 'react-popper-tooltip';
import 'react-popper-tooltip/dist/styles.css';
import { FiAlertCircle } from 'react-icons/fi';

// let modifiers = [
//   {
//     name: 'offset',
//     enabled: true,
//     options: {
//       offset: [40, 4],
//     },
//   },
// ];

const ToolTipPopper = ({ tooltip, className, ...props }) => (
  <TooltipTrigger
    placement="top-start"
    // modifiers={modifiers}
    {...props}
    modifiers={{
      preventOverflow: {
        escapeWithReference: false,
      },
    }}
    tooltip={({ getTooltipProps, getArrowProps, tooltipRef, arrowRef, placement }) => (
      <div
        {...getTooltipProps({
          ref: tooltipRef,
          className: `tooltip-container custom-tooltip-container ${className}`,
        })}
      >
        <div
          {...getArrowProps({
            ref: arrowRef,
            'data-placement': placement,
            className: 'tooltip-arrow custom-tooltip-arrow',
          })}
        />
        <div className="tooltip-body" style={{ maxWidth: '300px' }}>
          {tooltip
            ? tooltip
            : 'This box will auto-fill when you have selected the address of this Adventure Item on the map above.'}
        </div>
      </div>
    )}
  >
    {({ getTriggerProps, triggerRef }) => (
      <span
        {...getTriggerProps({
          ref: triggerRef,
          className: 'trigger tooltip--small',
        })}
      >
        <div>{props.icon ? props.icon : <FiAlertCircle />}</div>
      </span>
    )}
  </TooltipTrigger>
);

ToolTipPopper.propTypes = {
  placement: PropTypes.string,
  content: PropTypes.any,
  editIcon: PropTypes.bool,
  tooltip: PropTypes.string,
  size: PropTypes.number,
  icon: PropTypes.node,
  visible: PropTypes.bool,
  className: PropTypes.string,
};

export default ToolTipPopper;
